import React from "react";
import { connect, useDispatch } from "react-redux";
import { Link, withRouter, useHistory } from "react-router-dom";

//import {logout} from '../../store/actions/AuthActions';
import { isAuthenticated } from "../../redux/selectors/AuthSelectors";

const LogoutPage = (props) => {
  let history = useHistory();

  // remind by later added by divya
  const onLogout = () => {
    localStorage.clear("loginUserDetails");
    if (typeof window !== 'undefined') {
      sessionStorage.removeItem('rtwReminderDismissed');
      sessionStorage.removeItem('identityDocReminderDismissed');
      sessionStorage.removeItem('dbsReminderDismissed');
    }
    window.location.href = "/";
  };

  return (
    <React.Fragment>
      <Link
        style={{ display: props.isAuthenticated ? "inline-block" : "none" }}
        to={"#"}
        title="Logout"
        className="site-button"
        onClick={() => onLogout()}
      >
        <i className="fa fa-lock" /> Logout
      </Link>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(LogoutPage));
